import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthenticationService } from '../http/authentication.service';

export const loggedinGuard: CanActivateFn = () => {
  return inject(AuthenticationService).isAuthenticated();
};
